import type { FeatureFlag, FeatureFlagKey } from '@projektverwaltung/shared';
/**
 * Feature-Flags-Hook (F1). Liest GET /v1/feature-flags und cached global.
 * UI-Gating: Default `false` bis geladen — unfertige Features bleiben aus,
 * statt kurz aufzublitzen. Admin-Toggle siehe Admin-Tab "Feature-Flags".
 */
import { useQuery } from '@tanstack/react-query';
import { api } from './api.js';
import { useSession } from './session.js';

const FLAGS_QUERY_KEY = ['feature-flags'] as const;

export function useFeatureFlags(): {
  flags: Record<string, boolean>;
  items: FeatureFlag[];
  isLoading: boolean;
} {
  const { user } = useSession();
  const query = useQuery({
    queryKey: FLAGS_QUERY_KEY,
    queryFn: () => api.listFeatureFlags(),
    enabled: !!user,
    staleTime: 5 * 60_000,
  });
  const items = query.data?.items ?? [];
  const flags: Record<string, boolean> = {};
  for (const f of items) flags[f.key] = f.enabled;
  return { flags, items, isLoading: query.isLoading };
}

export function useFeatureFlag(key: FeatureFlagKey): boolean {
  const { flags } = useFeatureFlags();
  return flags[key] ?? false;
}

export { FLAGS_QUERY_KEY };
